// loading
export const LOADING = 'LOADING';
export const UNLOADING = 'UNLOADING';

// error
export const CLEAR_ERROR_FLG = 'CLEAR_ERROR_FLG';
export const ACCESS_DENIED = 'ACCESS_DENIED';

// result
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';
export const CLEAR_RESULT_FLG = 'CLEAR_RESULT_FLG';

// auth
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';

export const UPDATE_CARD = 'UPDATE_CARD';
export const COMPANY_INFO = 'COMPANY_INFO';

export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_FAILURE = 'REFRESH_TOKEN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const SEND_MAIL_RESET_PASSWORD_SUCCESS = 'SEND_MAIL_RESET_PASSWORD_SUCCESS';
export const SEND_MAIL_RESET_PASSWORD_FAILURE = 'SEND_MAIL_RESET_PASSWORD_FAILURE';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE';

// mypage
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_FAILURE = 'UPDATE_CUSTOMER_FAILURE';
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS';
export const ADD_ADDRESS_FAILURE = 'ADD_ADDRESS_FAILURE';
export const UPDATE_ADDRESS_SUCCESS = 'UPDATE_ADDRESS_SUCCESS';
export const UPDATE_ADDRESS_FAILURE = 'UPDATE_ADDRESS_FAILURE';
export const CLEAR_MYPAGE_RESULT_FLG = 'CLEAR_MYPAGE_RESULT_FLG';

// contact
export const SEND_MAIL_SUCCESS = 'SEND_MAIL_SUCCESS';
export const SEND_MAIL_FAILURE = 'SEND_MAIL_FAILURE';
export const CLEAR_CONTACT_RESULT_FLG = 'CLEAR_CONTACT_RESULT_FLG';

// cart
export const TOGGLE_CHANGE_CART = 'TOGGLE_CHANGE_CART';
export const SET_TOTAL_CART = 'SET_TOTAL_CART';
export const GET_CART_LIST_SUCCESS = 'GET_CART_LIST_SUCCESS';
export const GET_CART_LIST_FAILURE = 'GET_CART_LIST_FAILURE';
export const GET_CART_LIST_LOCAL_SUCCESS = 'GET_CART_LIST_LOCAL_SUCCESS';
export const DELETE_CART_ITEM_SUCCESS = 'DELETE_CART_ITEM_SUCCESS';
export const DELETE_CART = 'DELETE_CART';
export const GET_BUY_HISTORY_SUCCESS = 'GET_BUY_HISTORY_SUCCESS';
export const GET_BUY_HISTORY_FAILURE = 'GET_BUY_HISTORY_FAILURE';

// payment
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
export const PAYMENT_FAILURE = 'PAYMENT_FAILURE';
export const CLEAR_PAYMENT_RESULT = 'CLEAR_PAYMENT_RESULT';
export const GET_RULE_DISCOUNT_SUCCESS = 'GET_RULE_DISCOUNT_SUCCESS';
export const GET_RULE_DISCOUNT_FAILURE = 'GET_RULE_DISCOUNT_FAILURE';
// prefecture
export const GET_PREF_LIST_SUCCESS = 'GET_PREF_LIST_SUCCESS';
export const GET_PREF_LIST_FAILURE = 'GET_PREF_LIST_FAILURE';

// transaction
export const GET_TRANSACTION_LIST_SUCCESS = 'GET_TRANSACTION_LIST_SUCCESS';
export const GET_TRANSACTION_LIST_FAILURE = 'GET_TRANSACTION_LIST_FAILURE';

// Product
export const GET_PRODUCT_LIST_SUCCESS = 'GET_PRODUCT_LIST_SUCCESS';
export const GET_PRODUCT_LIST_FAILURE = 'GET_PRODUCT_LIST_FAILURE';
export const GET_PRODUCT_DETAIL_SUCCESS = 'GET_PRODUCT_DETAIL_SUCCESS';
export const GET_PRODUCT_DETAIL_FAILURE = 'GET_PRODUCT_DETAIL_FAILURE';
